var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notifications',{attrs:{"group":"cart","position":"bottom right"}}),_vm._v(" "),_c('navigation'),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animated fadeIn animation-delay-100","leave-active-class":"animated fadeOut animation-delay-100"}},[_c('router-view',{key:_vm.$route.fullPath})],1),_vm._v(" "),_c('mhdfooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98916dc8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 165
// module chunks = 0